'use client';

import { twMerge } from 'tailwind-merge';
import { CONFIG } from '@/global-config';

import { useTranslate } from '@/core/locales';
import { TRANSLATION_NAMESPACES } from '@/core/constants';

import { Link } from '@/components/ui';

import { RouterLink } from '@/routes/components';

export type LogoProps = {
  isSingle?: boolean;
  disabled?: boolean;
  className?: string;
  href?: string;
  [key: string]: any;
};

export function Logo({ disabled, className, href = '/', isSingle = false, ...other }: LogoProps) {
  const { t } = useTranslate(TRANSLATION_NAMESPACES.COMMON);

  const singleLogo = (
    <img
      alt={t('logo.title')}
      src={`${CONFIG.assetsDir}/logo/logo-single-2.svg`}
      width="100%"
      height="100%"
    />
  );

  const fullLogo = (
    <img
      alt={t('logo.title')}
      src={`${CONFIG.assetsDir}/logo/logo-full-2.svg`}
      width="100%"
      height="100%"
    />
  );

  return (
    <Link
      component={RouterLink}
      href={href}
      aria-label={t('logo.ariaLabel')}
      underline="none"
      className={twMerge(
        'flex-shrink-0 text-transparent inline-flex align-middle',
        isSingle ? 'w-10 h-10' : 'w-[186px] md:w-[261px] h-full max-h-[103px]',
        disabled && 'pointer-events-none',
        className
      )}
      {...other}
    >
      {isSingle ? singleLogo : fullLogo}
    </Link>
  );
}
